import { createSlice } from "@reduxjs/toolkit";
import { ConfigurationFieldNames } from "../../../_statics/ConfigurationStatics";
import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";
import { integrationReducerActions } from "../../../_commons/integration.reducer";

export const initialNewConfiguration = {
    [ConfigurationFieldNames.PLATFORM_CLIENT_UUID]: "",
    [ConfigurationFieldNames.URL]: "",
    [ConfigurationFieldNames.USERNAME]: "",
    [ConfigurationFieldNames.PASSWORD]: "",
};

export const initialStoreganizeReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: { ...initialNewConfiguration },
};

const storeganiseSlice = createSlice({
    name: "Storeganise",
    initialState: { ...initialStoreganizeReducer },
    reducers: {
        ...integrationReducerActions,
        toggleNewIntegration(state) {
            state.createConfigurationModal = !state.createConfigurationModal;
        },
        toggleDeleteIntegration(state, action) {
            state.configurationToBeDeleted = action.payload;
            state.deleteConfigurationModal = !state.deleteConfigurationModal;
        },

        setNewConfiguration(state, action) {
            state.newConfiguration = action.payload;
        },
        addNewIntegrationRequest(state) {
            state.submitted = true;
            state.isLoading = true;
            state.createErrorMessage = null;
        },
        addNewIntegrationSuccess(state, action) {
            let config = action.payload;
            let configs = state.configurations;
            if (configs.length > 0) {
                configs = configs.concat(config);
                configs.sort((a, b) =>
                    a[ConfigurationFieldNames.PLATFORM_CLIENT_UUID].toLowerCase() >
                    b[ConfigurationFieldNames.PLATFORM_CLIENT_UUID].toLowerCase()
                        ? 1
                        : a[ConfigurationFieldNames.PLATFORM_CLIENT_UUID].toLowerCase() <
                          b[ConfigurationFieldNames.PLATFORM_CLIENT_UUID].toLowerCase
                        ? -1
                        : 0
                );
            } else {
                configs = [config];
            }
            state.submitted = false;
            state.isLoading = false;
            state.createConfigurationModal = false;
            state.configurations = configs;
        },
        addNewIntegrationFailure(state, action) {
            state.submitted = false;
            state.isLoading = false;
            state.createErrorMessage = action.payload;
        },
        deleteConfigurationRequest(state) {
            state.isDeleteLoading = true;
            state.deleteErrorMessage = null;
        },
        deleteConfigurationSuccess(state) {
            state.configurations = state.configurations.filter((config) => {
                return config.externalUUID !== state.configurationToBeDeleted.externalUUID;
            });
            state.configurationToBeDeleted = null;
            state.deleteConfigurationModal = false;
            state.isDeleteLoading = false;
        },
        deleteConfigurationFailure(state, action) {
            state.isDeleteLoading = false;
            state.deleteErrorMessage = action.errorMessage;
        },
        getConfigurationRequest(state) {
            state.isLoading = true;
            state.configuration = null;
            state.errorMessage = null;
            state.successMessage = null;
        },
        getConfigurationSuccess(state, action) {
            state.isLoading = false;
            state.configuration = action.payload;
            state.errorMessage = null;
        },
        getConfigurationFailure(state, action) {
            state.isLoading = false;
            state.configuration = null;
            state.errorMessage = action.payload;
        },
        setEditConfiguration(state, action) {
            state.editConfiguration = action.payload;
        },
        setUnsavedChanges(state, action) {
            state.unsavedChanges = action.payload;
        },
        updateConfigurationRequest(state) {
            state.isUpdateLoading = true;
            state.configuration = null;
            state.updateErrorMessage = null;
            state.successMessage = null;
        },
        updateConfigurationSuccess(state, action) {
            state.isUpdateLoading = false;
            state.configuration = action.payload;
            state.successMessage = "Speichern erfolgreich.";
            state.advancedSettingsModal = false;
        },
        updateConfigurationFailure(state, action) {
            state.isUpdateLoading = false;
            state.configuration = null;
            state.updateErrorMessage = action.payload;
        },
        storeganiseImportRequest(state) {
            state.importData = null;
            state.isImportLoading = true;
            state.importErrorMessage = null;
            state.importSuccessMessage = null;
            state.errorMessage = null;
        },
        storeganiseImportSuccess(state, action) {
            state.importData = action.payload;
            state.importSuccessMessage = action.payload.notifications
                ? action.payload.notifications.map((notification) => notification.message)
                : undefined;
            state.isImportLoading = false;
        },
        storeganiseImportFailure(state, action) {
            state.importData = null;
            state.isImportLoading = false;
            state.importErrorMessage = action.payload;
        },

        performStoreganiseAccountingImportRequest(state) {
            state.isImportLoading = true;
            state.importData = null;
            state.importSuccessMessage = null;
            state.errorMessage = null;
            state.importErrorMessage = null;
        },
        performStoreganiseAccountingImportSuccess(state) {
            state.isImportLoading = false;
            state.importSuccessMessage =
                "Buchungsstapel wird erzeugt, Du erhältst eine E-Mail wenn der Abruf abgeschlossen ist.";
        },
        performStoreganiseAccountingImportFailure(state, action) {
            state.isImportLoading = false;
            state.importErrorMessage = action.payload.errorMessage;
        },

        toggleAdvancedSettingsModal(state) {
            state.advancedSettingsModal = !state.advancedSettingsModal;
        },

        resetSuccessMessages(state) {
            state.successMessage = null;
        },
    },
});

export default storeganiseSlice;
